import { Controller } from "@hotwired/stimulus"

// Soumet le formulaire dès qu'un champ change (filtres, propriétés du ticket).
export default class extends Controller {
  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), 120)
  }
}
